import { useEffect, useState } from 'react';
import { getAllDailyPuzzles } from 'services/api/dailyPuzzlesApi';
import { DailyPuzzle } from 'types/components/DailyPuzzle';

const initialStartDate = new Date();
initialStartDate.setDate(1);
initialStartDate.setHours(0, 0, 0);
const initialEndDate = new Date(initialStartDate);
initialEndDate.setDate(initialEndDate.getDate() + 29);
initialEndDate.setHours(23, 59, 59);

const useDailyPuzzles = () => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [data, setData] = useState<DailyPuzzle[]>([]);
  const [dateSort, setDateSort] = useState<'asc' | 'desc'>('desc');

  const fetch = async () => {
    if (isLoading) return;
    setIsLoading(true);
    const data = await getAllDailyPuzzles({ dateSort });
    setData(data);
    setIsLoading(false);
  };

  useEffect(() => {
    fetch();
  }, [dateSort]);

  const toggleDateSort = () => {
    setDateSort((prevState) => (prevState === 'desc' ? 'asc' : 'desc'));
  };

  return {
    data,
    dateSort,
    isLoading,

    toggleDateSort,
    fetch,
  };
};

export default useDailyPuzzles;
